// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ArrowIcon_arrow__cH9eB","disabled":"ArrowIcon_disabled__yAofN"};